import { render, staticRenderFns } from "./PanelForm.vue?vue&type=template&id=7a82883e&scoped=true&"
import script from "./PanelForm.vue?vue&type=script&lang=js&"
export * from "./PanelForm.vue?vue&type=script&lang=js&"
import style0 from "./PanelForm.vue?vue&type=style&index=0&id=7a82883e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a82883e",
  null
  
)

export default component.exports